const startGame = () => ({ type: 'START_GAME' });

export default startGame;



// WEBPACK FOOTER //
// ./src/actions/startGame.js